import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Typography } from '@mui/material';

import { AuthProvider } from './shared/contexts/AuthContext';
import { useAuth } from './shared/hooks/useAuth';
import UserLoginPage from './shared/components/auth/UserLoginPage';
import UserRegisterPage from './shared/components/auth/UserRegisterPage';
import MainLayout from './layouts/MainLayout';
import Header from './layouts/Header';

import { LicenseInfo} from '@mui/x-license';

LicenseInfo.setLicenseKey('d8dd04ef87e4d70b2dbe8bd2ee8a8763Tz0xMTYyOTcsRT0xNzg0NDE5MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=')

import './App.css';

// Import our theme context provider
import { ThemeSettingsProvider } from './styles/contexts/ThemeContext';

function AuthenticatedApp() {
  return <MainLayout />;
}

function UnauthenticatedApp() {
  const [view, setView] = useState('login');
  const { login } = useAuth();

  const handleLogin = async (credentials) => {
    await login(credentials);
  };

  const handleRegisterSuccess = () => {
    setView('login');
  };

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header 
        showTabs={false} 
        onViewChange={handleViewChange}
        currentView={view}
      />
      {view === 'login' ? (
        <UserLoginPage
          onLogin={handleLogin}
          onRegisterClick={() => setView('register')}
        />
      ) : (
        <UserRegisterPage
          onSuccess={handleRegisterSuccess}
          onCancel={() => setView('login')}
        />
      )}
    </Box>
  );
}

function AppContent() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return isAuthenticated ? <AuthenticatedApp /> : <UnauthenticatedApp />;
}

function App() {
  return (
    <ThemeSettingsProvider>
      <CssBaseline />
      <AuthProvider>
        <div className="App">
          <AppContent />
        </div>
      </AuthProvider>
    </ThemeSettingsProvider>
  );
}

export default App;